let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ea88v")).then(() => parcelRequire('jAZR7'));